export const STEP1_SUBMIT_REQUEST = "STEP1_SUBMIT_REQUEST";
export const STEP1_SUBMIT_SUCCESS = "STEP1_SUBMIT_SUCCESS";
export const STEP1_SUBMIT_FAILED = "STEP1_SUBMIT_FAILED";

export const CLEAR_STEP1_FORM_SUCCESS = "CLEAR_STEP1_FORM_SUCCESS";
